import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

export const REVIEWS = [
  { name: "Camille Dubois", city: "Melun", init: "CD", color: "bg-rose-500", text: "Porte claquée à 23h, le serrurier était là en 25 minutes et a ouvert sans rien casser. Impeccable et tarif annoncé à l'avance." },
  { name: "Karim Benali", city: "Meaux", init: "KB", color: "bg-indigo-500", text: "Changement de serrure après un cambriolage. Rapides, pro et rassurants. Ils ont même fourni le devis pour l'assurance." },
  { name: "Sophie Leroy", city: "Chelles", init: "SL", color: "bg-emerald-500", text: "Blindage de porte parfait, travail très soigné. Je me sens beaucoup plus en sécurité. Je recommande vivement." },
  { name: "Thomas Martin", city: "Serris", init: "TM", color: "bg-amber-500", text: "Intervention ultra rapide un dimanche. Le technicien a été honnête et efficace. Un grand merci !" },
  { name: "Nadia Cherif", city: "Torcy", init: "NC", color: "bg-cyan-600", text: "Serrure bloquée, réparée en 20 min. Personnel courtois et prix très correct. Je garde le numéro précieusement." },
  { name: "Julien Petit", city: "Fontainebleau", init: "JP", color: "bg-violet-500", text: "Excellent serrurier, ponctuel et professionnel. Devis clair, aucune surprise. Je recommande à 100%." },
];

export const GoogleG = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.8-6.8C35.6 2.4 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.2 17.7 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.5 3-2.2 5.5-4.7 7.2l7.3 5.7c4.3-3.9 6.9-9.7 6.9-17.4z"/>
    <path fill="#FBBC05" d="M10.5 28.3c-.5-1.5-.8-3-.8-4.8s.3-3.3.8-4.8l-7.9-6.1C.9 15.9 0 19.8 0 24s.9 8.1 2.6 11.4l7.9-7.1z"/>
    <path fill="#34A853" d="M24 48c6.2 0 11.5-2 15.3-5.6l-7.3-5.7c-2 1.4-4.7 2.3-8 2.3-6.3 0-11.6-3.7-13.5-9.7l-7.9 7.1C6.5 42.6 14.6 48 24 48z"/>
  </svg>
);

export const GoogleRating = ({ className = "" }) => (
  <div className={`inline-flex items-center gap-2.5 rounded-full border border-zinc-200 bg-white px-4 py-2 shadow-sm ${className}`} data-testid="google-rating">
    <GoogleG className="h-5 w-5" />
    <div className="flex items-center gap-0.5">{[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-primary text-primary" />)}</div>
    <span className="text-sm font-semibold text-zinc-900">4,9/5</span>
    <span className="text-xs text-zinc-500">· 1 277 avis Google</span>
  </div>
);

export default function ReviewsSection({ subtitle = "Ce que disent nos clients en Seine-et-Marne.", bg = "bg-white" }) {
  return (
    <section className={`relative z-10 py-24 sm:py-32 border-t border-zinc-200 ${bg}`} data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <div>
            <p className="overline mb-4">Avis clients</p>
            <h2 className="text-4xl sm:text-5xl font-display font-semibold tracking-tighter text-zinc-900 leading-[1.02]">Ils nous ont fait confiance</h2>
            <p className="text-zinc-500 mt-4">{subtitle}</p>
          </div>
          <GoogleRating />
        </Reveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={(i % 3) * 0.07} className="card-soft rounded-2xl border border-zinc-200 bg-white p-8 shadow-sm">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <span className={`grid place-items-center h-11 w-11 rounded-full text-white font-semibold ${r.color}`}>{r.init}</span>
                  <div><div className="font-medium text-zinc-900 leading-none">{r.name}</div><div className="text-xs text-zinc-400 mt-1">{r.city}</div></div>
                </div>
                <GoogleG className="h-5 w-5" />
              </div>
              <div className="flex mb-3">{[...Array(5)].map((_, j) => <Star key={j} className="h-4 w-4 fill-primary text-primary" />)}</div>
              <p className="text-zinc-700 leading-relaxed text-[0.95rem]">“{r.text}”</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
